<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_iii"></a><img alt="Image" src="images/figiii-01.jpg"/></p>
<h1 class="book-title">SEAL WARRIOR</h1>
<p class="sub-title">Death in the Dark: Vietnam 1968–1972</p>
<p class="linespace"> </p>
<p class="author">Thomas H. Keith<br/><span class="small"><em>Master Chief, SEAL Team 2, USN (Ret.)</em></span></p>
<p class="center-para"><img alt="Image" src="images/line.jpg"/></p>
<p class="editor">and J. Terry Riebling</p>
<p class="linespace"> </p>
<p class="center-para"><span class="small">Foreword by Michael E. Thornton,<br/><em>Lt., USN (Ret.)</em></span></p>
<p class="linespace"> </p>
<p class="editor"><a id="page_iv"></a><span class="smallcaps">THOMAS DUNNE BOOKS   <img alt="Image" src="images/publisher.jpg"/>   ST. MARTIN’S PRESS NEW YORK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?33a63d28